export const environment = {
    production: false,
    useMockSearchData: false, // 🚫 Mock data disabled in deployed environments
    appInsights: {
        instrumentationKey: 'df7cce5c-c3d0-4708-804b-5d542143bf2a',
        connectionString: 'InstrumentationKey=df7cce5c-c3d0-4708-804b-5d542143bf2a;IngestionEndpoint=https://westus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://westus.livediagnostics.monitor.azure.com/;ApplicationId=5df47b61-5ef3-439e-83de-40658f84c6b2'
    },
    queryParam_ept_id: 'patientID',
    queryParam_wpr_id: 'accountID',
    queryParam_timestamp: 'time',
    MCAppGatewayBaseURL: 'https://mhs-ape-appgateway-memorialcare-test-westus2.azurewebsites.net/api/',
    epic_client_id: '65eec747-aef2-476e-b609-62e7c90b4955',
    // MyChart Web Navbar
    web_mychart_home_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/Home',
    web_mychart_proxy_family_access_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/Proxies/FamilyAccess',
    web_mychart_personal_info_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/app/personal-information',
    web_mychart_security_settings_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/app/security-settings',
    web_mychart_logout_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/Authentication/Login?action=logout',
    mobile_mychart_logout_url: 'mymemorialcare://Authentication/Login?action=logout',
    epic_mychart_logout_url: 'epichttp://Authentication/Login?action=logout',
    // MILA need help deciding
    gyantt_mhs_org_id: 'mmc-mychart-fd',
    gyantt_base_url: 'https://web2.dev.gyantts.com/',
    web_mila_url: 'https://web2.dev.gyantts.com/gyant-embed.js',
    // PCP Scheduling 
    fm_specialty_id: '125',
    im_specialty_id: '117',
    ped_specialty_id: '17',
    office_visit_prc_id: '50317',
    office_visit_rfv_id: '61',
    mobile_scheduling_deep_link_base_url: 'mymemorialcare://scheduling',
    epic_scheduling_deep_link_base_url: 'epichttp://scheduling',
    web_scheduling_deep_link_base_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/scheduling',
    default_provider_photo_url: 'https://www.memorialcare.org/themes/custom/memorialcare/assets/img/provider_placeholder-transparent.png',
    // Open Scheduling
    mobile_open_scheduling_deep_link_base_url: 'mymemorialcare://openscheduling',
    epic_open_scheduling_deep_link_base_url: 'epichttp://openscheduling',
    web_open_scheduling_deep_link_base_url: 'https://mymemorialcaretst19.memorialcare.org/mycharttst/openscheduling',
    // OMW/IPUC
    epic_omw_deep_link_base_url: 'epichttp://onmyway?seldepid=',
    mobile_omw_deep_link_base_url: 'mymemorialcare://onmyway?seldepid=',
    web_omw_deep_link_base_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/Scheduling/OnMyWay/PostLogin?seldepid=',
    web_unauth_omw_deep_link_base_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/Scheduling/OnMyWay?seldepid=',
    // VUC
    generic_vuc_provider_id: '7000892',
    pediatric_vuc_rfv_id: '52220', // for provider-specific deeplink
    adult_vuc_rfv_id: '52216',     // for provider-specific deeplink
    pediatric_vuc_prc_id: '9999101', // for show-more deeplink
    adult_vuc_prc_id: '9999100', // for show-more deeplink
    // VUC deep links
    mobile_vuc_deep_link_base_url: 'mymemorialcare://ondemandtelehealth?location=233&sublocation=5&quickschedulestep=hideifone&referringPage=landingpage&selRfvId=',
    epic_vuc_deep_link_base_url: 'epichttp://ondemandtelehealth?location=233&sublocation=5&quickschedulestep=hideifone&referringPage=landingpage&selRfvId=',
    web_vuc_deep_link_base_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/Scheduling/OnDemandTelehealth?location=233&sublocation=5&quickschedulestep=hideifone&referringPage=landingpage&selRfvId=',
    // QuickCare deep links (authenticated)
    epic_quickcare_deep_link_base_url: 'epichttp://fdiredirect?webid=WP-241-2B19Jj8RJwVqbfhxOaG-2FBA-3D-3D-24tucxVQdrC7VrZm-2BfB4tkiadYHguvsJUjq74SpqsS2SY-3D',
    mobile_quickcare_deep_link_base_url: 'mymemorialcare://fdiredirect?webid=WP-241-2B19Jj8RJwVqbfhxOaG-2FBA-3D-3D-24tucxVQdrC7VrZm-2BfB4tkiadYHguvsJUjq74SpqsS2SY-3D',
    web_quickcare_deep_link_base_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/inside.asp?litemode=true&mode=fdiredirect&option=Fabric',
    //QuickCare deep links (unauthenticated)
    web_quickcare_unauth_deep_link_base_url: 'https://memorialcare.zipnosis.com',
    // FDI deep links
    epic_fdi_deep_link_base_url: 'epichttp://fdiredirect?',
    mobile_fdi_deep_link_base_url: 'mymemorialcare://fdiredirect?',
    web_fdi_deep_link_base_url: 'https://mymemorialcaretst19.memorialcare.org/MyChartTST/inside.asp?litemode=true&mode=fdiredirect&option=',
    fdi_option_qc_cough: 'Fabric_Covid',
    fdi_option_qc_skin: 'Fabric_Skin',
    fdi_option_qc_ear: 'Fabric_Ear',
    fdi_option_qc_pinkeye: 'Fabric_Eye',
    fdi_option_qc_stomach: 'Fabric_Stomach',
    fdi_option_qc_uti: 'Fabric_UTI',
    fdi_option_qc_yeast: 'Fabric_Yeast',
    // Google Map Address
    web_google_map: 'https://www.google.com/maps/search/?api=1&query=',
    // Pre-login feature deeplinks
    // Get Care Now
    mobile_get_care_now_fdi: 'WP-24iNtkbz5L76eWD6vAnHY0FQ-3D-3D-247EnqEwKtyLwMJlPt0DvIlsrIyibVIlcQBrc4je-2FLuhY-3D',
    web_get_care_now_deep_link_base_url: 'https://gentle-beach-0d4bfdb1e-test.westus2.2.azurestaticapps.net/get-care-now',
    // Login
    mobile_login_deep_link_base_url: 'mymemorialcare://Authentication/Login',   
    // Chat Bot
    mobile_open_chat_bot_deep_link_base_url: 'https://web2.dev.gyantts.com/gyant-embed/?org=mmc-mychart-fd',   
    // Provider Search
    mobile_provider_search_fdi: 'WP-24-2Flk2Ef6IH9EHOCSZwCtxGQ-3D-3D-24J4l0v-2BhZgNJG9IPPJv6gungtIIDgolBVtyqdHFtlJhI-3D',   
    web_provider_search_deep_link_base_url: 'https://gentle-beach-0d4bfdb1e-test.westus2.2.azurestaticapps.net/find-care?mode=provider',
    // Location Search
    mobile_location_search_fdi: 'WP-243SH912KtaCbhpb7iABlHwg-3D-3D-24CufU22BjbzSL4duCEK0d-2F4W78VEI-2F0LpXFfrYgWpspY-3D',   
    web_location_search_deep_link_base_url: 'https://gentle-beach-0d4bfdb1e-test.westus2.2.azurestaticapps.net/find-care?mode=location'
}